export const Delimiters = {
  bullet: ' • ',
}
